class ProductAvailabilityToggle extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('data-product-id');
    this.productButtonsContainer = this.querySelector(`#product-buttons-container-${this.productId}`);
    this.klaviyoBisContainer = this.querySelector(`#klaviyo-bis-container-${this.productId}`);      
  }

  connectedCallback() {
    const initialAvailable = this.getAttribute('data-initial-available') === 'true';
    this.toggle(initialAvailable);

    this.onVariantChange = (event) => {
      if(event.target.dataset.productId !== this.productId) return;
      
      const variant = event.detail?.variant;
      if (!variant) return;

      const bisForm = this.querySelector('klaviyo-bis');
      if (bisForm) {
        bisForm.dataset.variantId = variant.id;
      }

      this.toggle(variant.available);
    };

    document.addEventListener('theme:variant:change', this.onVariantChange);
  }

  disconnectedCallback() {
    if (this.onVariantChange) {
      document.removeEventListener('theme:variant:change', this.onVariantChange);
    }
  }

  toggle(isAvailable) {
    if (this.productButtonsContainer) {
      this.productButtonsContainer.style.display = isAvailable ? 'block' : 'none';
    }
    if (this.klaviyoBisContainer) {
      this.klaviyoBisContainer.style.display = isAvailable ? 'none' : 'block';
    }
  }
}

if (!customElements.get('product-availability-toggle')) {
  customElements.define('product-availability-toggle', ProductAvailabilityToggle);
}
